import { useMemo } from 'react';
import { useDi, API_BASE_URL } from '../../app/providers/DiProvider';
import { AgreementApi } from './agreement.api';

/** Resolves the AgreementApi client from the DI container (base URL comes from env). */
export function useAgreementApi(): AgreementApi {
  const di = useDi();
  return useMemo(() => new AgreementApi(di.resolve(API_BASE_URL)), [di]);
}
